module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "op--message"
  }, [_vm._v("\n    " + _vm._s(_vm.$t('rsvpTrack.bestExp', {
    brandName: _vm.brandName
  })) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "row margin-t-xs"
  }, [_c('div', {
    staticClass: "small-6 column padding-r-xs"
  }, [_c('a', {
    staticClass: "op-btn btn-block",
    attrs: {
      "href": _vm.appLinks.ios,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fab fa-apple"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('rsvpTrack.appStore')))])])]), _vm._v(" "), _c('div', {
    staticClass: "small-6 column padding-l-xs"
  }, [_c('a', {
    staticClass: "op-btn btn-block",
    attrs: {
      "href": _vm.appLinks.android,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fab fa-google-play"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('rsvpTrack.playStore')))])])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-72cf077e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-72cf077e","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RsvpTrack/ConsumerAppLinks.vue
// module id = 2111
// module chunks = 0